const MAX_ALLOWED_CHARACTERS = 400;

export const useSummaryDynamicMaxLength = (summary = ''): number => {
    if (summary.length >= MAX_ALLOWED_CHARACTERS && summary?.length <= 5000) {
        return summary?.length;
    }

    return MAX_ALLOWED_CHARACTERS;
};

export const useTruncateSummary = (
    summary = '',
    maxLength: number = MAX_ALLOWED_CHARACTERS
): string => (summary.length > maxLength ? summary.substring(0, maxLength) + '...' : summary);
